module.exports = __webpack_public_path__ + "assets/7d0688e9f7d3093e5d9352b55e175790.png";